import React from 'react';
import { Helmet } from 'react-helmet-async';
import { observer } from 'mobx-react-lite';
import { useLanguage } from '../../contexts/LanguageContext.jsx';
import { LINKS } from '../../constants.js';

export const SEO = observer(() => {
  const { t, language } = useLanguage();
  const { hero, features } = t;
  const url = 'https://waifubriscola.com';
  const schema = {
    '@context': 'https://schema.org',
    '@type': ['SoftwareApplication', 'VideoGame'],
    name: 'Waifu Briscola',
    description: hero.tagline,
    operatingSystem: 'Android, iOS, Web',
    applicationCategory: 'GameApplication',
    genre: ['Card Game', 'RPG', 'Anime'],
    inLanguage: language,
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR' },
    aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.8', ratingCount: '1250' },
    featureList: features.items.map((f) => f.title).join(', '),
    author: { '@type': 'Person', name: 'Mauro Mazzocchetti' },
    image: LINKS.logo
  };
  return (
    <Helmet>
      <html lang={language} />
      <title>{hero.title + ' - ' + hero.tagline}</title>
      <meta name="description" content={hero.tagline + ' ' + features.items[0].description} />
      <meta name="keywords" content={'briscola, anime, waifu, card game, rpg, ' + (language === 'it' ? 'gioco di carte' : 'card game')} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={hero.title} />
      <meta property="og:description" content={hero.tagline} />
      <meta property="og:image" content={LINKS.logo} />
      <meta property="og:locale" content={language} />
      <meta property="og:site_name" content="Waifu Briscola" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={hero.title} />
      <meta name="twitter:description" content={hero.tagline} />
      <meta name="twitter:image" content={LINKS.logo} />
      <meta name="theme-color" content="#0E0B1F" />
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
});

